<template>
  <div class="wt-container align-items-center">
    <div class="card shadow-sm p-4" :class="{ wide: showAll }">
      <h2 class="text-center mb-4">User Info</h2>
      <template v-if="!showAll">
        <p class="lead text-center mb-4">This is the information that we keep about you.</p>
        <div class="cnt mb-3">
          <table class="table table-striped mb-3">
            <thead>
              <tr>
                <th colspan="2">Your Account</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Email Address</td><td>{{ user.emailAddress }}</td>
              </tr>
              <tr>
                <td>Registered</td><td>{{ user.timestamp }}</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped">
            <thead>
              <tr>
                <th colspan="2">Your Assessments</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Commodity Assessments</td><td>{{ user.numType101Scenarios }}</td>
              </tr>
              <tr>
                <td>Business Assessments Without Supply Chain</td><td>{{ user.numType10Scenarios }}</td>
              </tr>
              <tr>
                <td>Business Assessments With Supply Chain</td><td>{{ user.numType11Scenarios }}</td>
              </tr>
              <tr>
                <td>First Assessment</td><td>{{ user.earliestScenarioTimestamp }}</td>
              </tr>
              <tr>
                <td>Last Assessment</td><td>{{ user.latestScenarioTimestamp }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="users.length > 1" class="text-center">
          <button type="button" @click="showAll = true" class="btn btn-link">Show all users</button>
        </div>
      </template>
      <template v-else>
        <p class="lead text-center mb-4">{{ users.length }} users have an account. {{ usersThatHaveScenarios.length }} of them have one or more assessments.</p>
        <div class="cnt mb-3">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th colspan="2">Account</th>
                <th colspan="5">Assessments</th>
              </tr>
              <tr>
                <th rowspan="2">Email Address</th>
                <th rowspan="2">Registered</th>
                <th rowspan="2" style="position: relative; color: #fff">Supply<div style="position: absolute; bottom: 47px; left: -12px; color: initial; transform: rotate(-90deg)">Commodity</div></th>
                <th colspan="2">Business</th>
                <th rowspan="2">First Created</th>
                <th rowspan="2">Last Created</th>
              </tr>
              <tr>
                <th>Without Supply Chain</th>
                <th>With Supply Chain</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user of users">
                <td>{{ user.emailAddress }}</td>
                <td>{{ user.timestamp }}</td>
                <td style="text-align: right">{{ user.numType101Scenarios }}</td>
                <td style="text-align: right">{{ user.numType10Scenarios }}</td>
                <td style="text-align: right">{{ user.numType11Scenarios }}</td>
                <td>{{ user.earliestScenarioTimestamp }}</td>
                <td>{{ user.latestScenarioTimestamp }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <div class="text-center">
        <button type="button" @click="close()" class="btn btn-link">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import { userModel } from "@/services/user-model";

export default {
  name: "UserInfo",
  data() {
    return {
      showAll: false
    };
  },
  computed: {
    user() {
      return userModel.users.find(user => user.emailAddress == userModel.user.emailAddress);
    },
    users() {
      return userModel.users;
    },
    usersThatHaveScenarios() {
      return userModel.users.filter(user => user.numType10Scenarios + user.numType11Scenarios + user.numType101Scenarios);
    }
  },
  methods: {
    close() {
      userModel.users = null;
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  max-width: 670px;
  max-height: 92%;
  margin: auto 0;
  &.wide {
    max-width: 1080px;
  }
  .cnt {
    flex-grow: 1;
    min-height: 100px;
    overflow: auto;
  }
}
</style>